module.exports = __webpack_public_path__ + "img/DW365-023.5a7324d9.jpg";